import React from "react";
 

import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS,LOCAL_PATHS } from "../../../Constants";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";

const ListPayrollSetup = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [year, setyear] = useState('')
  const [month, setmonth] = useState('')
const [showModal, setshowModal] = useState(false)
const [selected_payroll, setselected_payroll] = useState(null)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const toggle = () => setshowModal(!showModal);
 
  useEffect(() => {
    fetch_data();
    setyear(getCurrentYear())
    return () => {};
  }, []);
const getCurrentYear=()=>{
  return new Date().getFullYear();
}
  const fetch_data = () => {
    setIsLoading(true);
 
    genericGet(ENDPOINTS.LIST_PAYROLL_SETUP, {})
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
 
  };
  const runPayroll =  (e) => {
    setIsLoading(true)
    e?.preventDefault();
   let data= {
      "payroll_id": selected_payroll?.id,
      "month":month,
      "year":year
  }
  
   
  console.clear();
  console.log(data);
  console.log(ENDPOINTS.INITIALIZE_PAYROLL)
  genericPost(ENDPOINTS.INITIALIZE_PAYROLL, data)
  .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
              console.log("Go to Selection",{
                payroll_info: response.data.data,
                payroll_id:selected_payroll?.id,
                month:month,
                year:year
            })
            
              history.push({
                  pathname: LOCAL_PATHS.PAYROLL_SELECTION,
                  state: {
                      payroll_info: response.data.data,
                      payroll_id:selected_payroll?.id,
                      month:month,
                      year:year
                  },
              });
          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }
  return (
    <div>
      <div className="row">
        <div className="col-md-2">
          <h1> Payroll List Setup</h1>
        </div>
        <div className="col-md-10">
      
        </div>
      </div>
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerName: "Payroll Name",
              field: "name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Created at",
              field: "created_at",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Updated ",
              field: "created_at",
              sortable: true,
              filter: true,
            },
             
            {
              headerName: "Run ",
              field: "",
              sortable: true,
              filter: true,
              cellStyle: function (params) {
                return { color: "white", backgroundColor: "#FFF" };
              },
              cellRendererFramework: (e) => {
                return (
                  <div>
       {ability.can(PERMS.UPDATE, PERMS.UPDATE_SURVEYS) && (

                  <button
                  className="badge btn-primary"
                    onClick={() => {
                      setshowModal(true);
                      setselected_payroll(e.data)
                      // history.push({
                      //   pathname: "/ebms/surveys/create",
                      //   state: { _survey: e.data },
                      // });
                    }}
                  >
                   
                    
                    RUN PAYROLL &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>)}</div>

                );
              },
            },
          ]}
        ></AgGridReact>
      </div>{" "}
      <Modal
        isOpen={showModal}
        onHide={() => setshowModal(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             Run : {selected_payroll?.name}
               
               
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      

        <form onSubmit={runPayroll}>
<div className="row">
 <div className="col-md-6">
    Month  
    <select name="month"
            className="form-control"
            onChange={(e) => {setmonth(e.target.value)}
               
             
            }
            required={true}
          >
            <option value=''>Select Month </option>
            <option value={1}>January </option>
            <option value={2}>February </option>
            <option value={3}>March </option>
            <option value={4}>April </option>
            <option value={5}>May </option>
            <option value={6}>Jun </option>
            <option value={7}>July </option>

            <option value={8}>August </option>
            <option value={9}>September </option>
            <option value={10}>October </option>
            <option value={11}>November </option>
            <option value={12}>December </option>

          


            
          </select>

</div>
 
<div className="col-md-6">  Year
<select className="form-control" name="year" onChange={(e)=>setyear(e.target.value)}>
  <option value={getCurrentYear()}>{getCurrentYear()}</option>
  <option value={Number(getCurrentYear()-1)}>{Number(getCurrentYear()-1)}</option>

</select>
 
  </div>
  
<br/>

    </div>
    <br/>  
    <div className="row">
  {!is_loading?
    <input  type="submit" className="btn btn-primary" value="Run Payroll" ></input> : <button className="btn btn-primary" disabled={true}><Spinner /> &nbsp; Processing..</button>  }

  </div>
    </form>
        </ModalBody>
      
      </Modal>
    </div>



  );
};

export default ListPayrollSetup;
